import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const resources = [
  { title: 'The Guide to Selling Your Home', desc: 'A complete step-by-step guide to help you navigate the entire selling process — from preparation to closing.', external: 'https://tinyurl.com/carolsellersguide', featured: true },
  { title: 'Preparing Your Home for Sale', desc: 'Practical steps to get your property market-ready — from decluttering to curb appeal.', slug: 'best-way-to-sell-house' },
  { title: 'Understanding Your Home\'s Value', desc: 'How property values are determined and what factors matter most.', slug: 'best-way-to-sell-house' },
  { title: 'Questions to Ask Before Choosing an Agent', desc: 'What to look for when selecting the right professional to represent your property.', href: '/about' },
  { title: 'How to Make a Strong First Impression', desc: 'Simple, affordable ways to help your home stand out to buyers.', slug: 'best-way-to-sell-house' },
  { title: 'What Happens After You Receive an Offer?', desc: 'Understanding the offer review, negotiation and acceptance process.', slug: 'best-way-to-sell-house' },
  { title: 'Selling and Buying at the Same Time', desc: 'How to coordinate both transactions without unnecessary stress.', href: '/sell-your-home' },
  { title: 'Downsizing Your Home', desc: 'Guidance for homeowners ready to move to a smaller, more manageable property.', slug: '5-key-signs-sell-home-retire' },
  { title: 'Selling an Inherited Property', desc: 'Navigating the emotional and practical aspects of selling a loved one\'s home.', href: '/sell-your-home' },
  { title: 'Moving and Relocation Checklist', desc: 'A practical guide to staying organised during a move.', href: '/sell-your-home' },
  { title: 'Common Home-Selling Mistakes', desc: 'What to watch out for — and how to avoid unnecessary delays or costs.', slug: 'best-way-to-sell-house' },
];

export default function SellerResources() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />

      {/* Hero */}
      <section className="py-16 md:py-24 bg-background-100/70">
        <div className="max-w-[800px] mx-auto px-4 md:px-6 lg:px-10 text-center">
          <p className="text-primary-500 font-body text-sm tracking-widest uppercase mb-3">Resources</p>
          <h2 className="font-heading text-foreground-900 text-3xl md:text-4xl lg:text-5xl mb-5">
            Seller Resources
          </h2>
          <p className="text-foreground-600 font-body text-base md:text-lg max-w-[600px] mx-auto">
            Helpful guides, checklists and advice to help you navigate the home-selling process with confidence.
          </p>
        </div>
      </section>

      {/* Resources Grid */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-[1100px] mx-auto px-4 md:px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {resources.map((r, i) => {
              const CardContent = () => (
                <>
                  <div className={`w-10 h-10 flex items-center justify-center rounded-md mb-4 transition-colors ${r.featured ? 'bg-primary-100 group-hover:bg-primary-200' : 'bg-accent-100 group-hover:bg-accent-200'}`}>
                    <i className={`${r.featured ? 'ri-book-open-line text-primary-700' : 'ri-file-text-line text-accent-700'} text-lg`} />
                  </div>
                  <h3 className="font-heading text-foreground-900 text-base mb-2 group-hover:text-primary-600 transition-colors">
                    {r.title}
                  </h3>
                  <p className="text-foreground-600 font-body text-xs leading-relaxed">
                    {r.desc}
                  </p>
                  {r.external && (
                    <span className="inline-flex items-center gap-1 mt-3 text-primary-600 font-body text-xs font-semibold">
                      View Guide
                      <i className="ri-arrow-right-up-line" />
                    </span>
                  )}
                </>
              );

              if (r.external) {
                return (
                  <a
                    key={i}
                    href={r.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`group border rounded-lg p-6 transition-all duration-300 ${r.featured ? 'bg-primary-50 border-primary-200/70 hover:border-primary-400/60' : 'bg-background-50 border-background-200/70 hover:border-primary-200/60'}`}
                  >
                    <CardContent />
                  </a>
                );
              }

              return (
                <Link
                  key={i}
                  to={r.slug ? `/blog/${r.slug}` : (r.href || '/blog')}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200/60 transition-all duration-300"
                >
                  <CardContent />
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-foreground-950">
        <div className="max-w-[700px] mx-auto px-4 md:px-6 lg:px-10 text-center">
          <h2 className="font-heading text-accent-100 text-2xl md:text-3xl mb-4">
            Have a Question About Selling?
          </h2>
          <p className="text-background-100/70 font-body text-base mb-8">
            Carol is happy to discuss your situation and answer any questions you may have — no obligation.
          </p>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-md text-base font-body font-semibold whitespace-nowrap hover:bg-primary-600 transition-all">
            <i className="ri-chat-3-line text-lg" />Talk to Carol
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}